/**
 * ssoSession.js — turn SSO access/refresh tokens into a stored Nexuma session.
 *
 * Shared by the web hash callback (SsoCallback.js) and the Electron deep-link
 * bridge (App.js). Produces the exact same `logedInUser` shape that the
 * email/password flow in SignIn.js stores, so the rest of the app is unaware
 * which login path was used.
 */

import { persistLogedInUser } from './sessionPersistence';

/**
 * @param {string} token        access JWT issued by /api/auth/google/callback
 * @param {string} refreshToken refresh JWT
 * @returns {Promise<boolean>}  true when the session was stored
 */
export async function applySsoTokens(token, refreshToken) {
  if (!token) return false;
  const backendUrl = process.env.REACT_APP_API_URL || '';

  const res = await fetch(`${backendUrl}/api/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json();
  if (!data?.success || !data?.data?.user) return false;

  const u = data.data.user;
  const session = {
    success: true,
    data: {
      id: u.id,
      username: u.username || (u.email || '').split('@')[0],
      firstname: u.firstname,
      lastname: u.lastname,
      email: u.email,
      roles: u.roles || [u.user_role || 'employee'],
      worker_id: u.worker_id || null,
      WorkerId: u.worker_id || null,
    },
    roles: u.roles || [u.user_role || 'employee'],
    token,
    company: 'hr',
    subscription: null,
    WorkerId: u.worker_id || null,
    worker_id: u.worker_id || null,
  };

  // Desktop (Electron): ruaj sesionin afatgjatë → kyçje vetëm herën e parë.
  persistLogedInUser(JSON.stringify(session), false);
  if (refreshToken) {
    try { sessionStorage.setItem('refreshToken', refreshToken); } catch (_) {}
    try { localStorage.setItem('refreshToken', refreshToken); } catch (_) {}
  }
  return true;
}

/** Parse token/refresh/error from a query string (works for hash-router callbacks). */
export function parseTokensFromSearch(search) {
  const params = new URLSearchParams(search || '');
  return {
    token: params.get('token') || '',
    refresh: params.get('refresh') || '',
    error: params.get('error') || '',
  };
}
